import ModelTypeConstants from 'constants/ModelTypeConstants';

export const TEMPLATE_COLLECTIBLE_TYPES = [
  ModelTypeConstants.TEMPLATE,
  ModelTypeConstants.SUBTEMPLATE,
  ModelTypeConstants.FORM_DEFINITION,
  ModelTypeConstants.REQUEST_V2_DEFINITION,
  ModelTypeConstants.ASSAY_PROCEDURE,
  ModelTypeConstants.RECIPE_PROCEDURE,
  ModelTypeConstants.ANALYSIS_TEMPLATE,
  ModelTypeConstants.PLATE_DESIGN_TEMPLATE,
];
